import React from "react";

export default function Home() {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <h1 className="text-4xl font-bold mb-4">Welcome to the Agency Dashboard</h1>
      <p className="text-lg text-gray-600">Use the navigation to manage users and view administrative data.</p>
    </div>
  );
}
